// extracted by mini-css-extract-plugin
export default {"lockIcon":"RoleSwitch_lockIcon__cVkEB"};